/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_A7Inputs */

const en_to_csv_faq_a7 = /** @type {(inputs: To_Csv_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, records are separated by a single line feed. Virtually every spreadsheet and parser accepts this, but a strict RFC 4180 implementation expects a carriage return and line feed pair, so convert the line endings if you are feeding a pedantic consumer.`)
};

const ko_to_csv_faq_a7 = /** @type {(inputs: To_Csv_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아닙니다. 레코드는 라인 피드 하나로 구분됩니다. 사실상 모든 스프레드시트와 파서가 이를 받아들이지만, 엄격한 RFC 4180 구현은 캐리지 리턴과 라인 피드 쌍을 기대하므로, 까다로운 소비자에게 넘길 때는 줄바꿈을 변환하세요.`)
};

const ja_to_csv_faq_a7 = /** @type {(inputs: To_Csv_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ、レコードはラインフィード 1 つで区切られます。事実上すべての表計算とパーサがこれを受け入れますが、厳格な RFC 4180 の実装はキャリッジリターンとラインフィードの対を期待するので、細かい相手に渡すときは改行を変換してください。`)
};

/**
* | output |
* | --- |
* | "No, records are separated by a single line feed. Virtually every spreadsheet and parser accepts this, but a strict RFC 4180 implementation expects a carriage..." |
*
* @param {To_Csv_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_a7 = /** @type {((inputs?: To_Csv_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_a7(inputs)
	if (locale === "ko") return ko_to_csv_faq_a7(inputs)
	return ja_to_csv_faq_a7(inputs)
});